var CONFUSEDCORE = CONFUSEDCORE || {};

// This function runs when the page is loaded
(function ($) {
	var pageUrl = window.location.href;

	// RUN COOKIE POPUP WIDGET
	var cookiePolicyWidget = window.Confused.CookiePolicyWidget;
	cookiePolicyWidget.run();

	//CONFUSEDCORE.MI.MiListener.postLogSession('LogNewSession');
	// TRIGGER NEW SESSION CALL IN MI - WAIT FOR CALLBACK FROM SESSION CALL THEN TRIGGER COOKIE POPUP SHOWN EVENT
	var miListener = CONFUSEDCORE.MI.MiListener;
	miListener.postPageView('LogPageView', { page: pageUrl, referer: document.referrer }, function () {
		if (cookiePolicyWidget.wasCookiePopupShown()) {
			miListener.postEvent('CookiePopupShown');
		}
	});
})(window.jQuery);
